// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.field-container {
  display: grid;
  grid-template-columns: 200px 1fr 30px;
  border-bottom: 1px solid #D3E1ED;
  padding: 12px 0;
  font-size: 14px;
}
.field-container .field-edit-icon {
  width: 20px;
  cursor: pointer;
}
.field-container .field-title {
  color: #6A8991;
}`, "",{"version":3,"sources":["webpack://./src/components/FieldGroup/Field/Field.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,qCAAA;EACA,gCAAA;EACA,eAAA;EACA,eAAA;AACD;AACC;EACC,WAAA;EACA,eAAA;AACF;AAEC;EACC,cAAA;AAAF","sourcesContent":[".field-container {\n\tdisplay: grid;\n\tgrid-template-columns: 200px 1fr 30px;\n\tborder-bottom: 1px solid #D3E1ED;\n\tpadding: 12px 0;\n\tfont-size: 14px;\n\n\t.field-edit-icon {\n\t\twidth: 20px;\n\t\tcursor: pointer;\n\t}\n\n\t.field-title {\n\t\tcolor: #6A8991;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
